/**
 * Transforms a UTC date from the database to local time for frontend use
 */
export function fromUTC(utcDate: string | Date | null): Date | null {
  if (!utcDate) return null;
  const date = new Date(utcDate);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

/**
 * Transforms a local date from the frontend to UTC for database storage
 */
export function toUTC(localDate: Date | null): string | null {
  if (!localDate) return null;
  const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
  return utcDate.toISOString();
}

/**
 * Formats a date as YYYY-MM-DD string (without time component)
 */
export function toPlainDateString(date: Date | null | string): string | null {
  if (!date) return null;
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toISOString().split('T')[0]; // Gets just the YYYY-MM-DD part
}

/**
 * Creates a Date object from a string in YYYY-MM-DD format
 * @param isoDateString A string in ISO date format (YYYY-MM-DD)
 * @returns Date object representing the input date in local timezone
 */
export function parsePlainDateString(isoDateString: string | null): Date | null {
  if (!isoDateString) return null;
  // The dateString should be in YYYY-MM-DD format
  // When creating a new Date with just the date string, it will be interpreted as UTC at midnight
  // We want to return a Date object representing that date in the local timezone
  const [year, month, day] = isoDateString.split('-').map(num => parseInt(num, 10));
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
  
  return new Date(year, month - 1, day); // month is 0-indexed in JavaScript Date
}
